export default __webpack_public_path__ + "static/media/Mark-3-Suit-11.19016e98.jpg";